require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/$.core').Object.getPrototypeOf;


//////////////////
// WEBPACK FOOTER
// ./~/_core-js@1.2.7@core-js/library/fn/object/get-prototype-of.js
// module id = 387
// module chunks = 0